import { CdkTextareaAutosize, TextFieldModule } from '@angular/cdk/text-field';
import { AfterViewInit, Component, ElementRef, EventEmitter, inject, Input, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormsModule, ReactiveFormsModule, UntypedFormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton, MatFabButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatError, MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { AnalyzedImage, BoolParam, CodeParam, CanvasParam, FileParam, Img, NumParam, OpInput, OpParamVal, OpParamValType, SelectParam, StringParam } from 'adacad-drafting-lib';
import { MediaInstance, OpNode, OpStateParamChange } from '../../../../core/model/datatypes';
import { MediaService } from '../../../../core/provider/media.service';
import { OperationService } from '../../../../core/provider/operation.service';
import { StateService } from '../../../../core/provider/state.service';
import { TreeService } from '../../../../core/provider/tree.service';
import { ImageeditorComponent } from '../../../../core/ui/imageeditor/imageeditor.component';
import { TextparamComponent } from '../../../../core/ui/textparam/textparam.component';
import { UploadFormComponent } from '../../../../core/ui/uploads/upload-form/upload-form.component';
import { MaterialsService } from '../../../../core/provider/materials.service';
import { Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';
import * as p5 from 'p5';

export function regexValidator(nameRe: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const globalRegex = new RegExp(nameRe, 'g');
    const valid = globalRegex.test(control.value);
    return !valid ? { forbiddenInput: { value: control.value } } : null;
  };
}



@Component({
  selector: 'app-parameter',
  templateUrl: './parameter.component.html',
  styleUrls: ['./parameter.component.scss'],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatFormField, MatError, MatFabButton, TextFieldModule, MatLabel, MatInput, FormsModule, ReactiveFormsModule, MatSelect, MatOption, MatButton, UploadFormComponent]
})
export class ParameterComponent implements OnInit, AfterViewInit, OnDestroy {
  tree = inject(TreeService);
  ss = inject(StateService);
  dialog = inject(MatDialog);
  ops = inject(OperationService);
  mediaService = inject(MediaService);
  materialsService = inject(MaterialsService);


  fc!: UntypedFormControl;
  opnode!: OpNode;

  name: any;

  @Input() param!: NumParam | StringParam | SelectParam | BoolParam | FileParam | CodeParam | CanvasParam;
  @Input() opid!: number;
  @Input() paramid!: number;
  @Output() onOperationParamChange = new EventEmitter<any>();
  @Output() onFileUpload = new EventEmitter<any>();
  @Output() preventDrag = new EventEmitter<any>();

  fromUser: boolean = true;

  has_image_uploaded: boolean = false;
  filewarning: string = '';
  true_state_langauge: string = '';
  false_state_langauge: string = '';
  param_selectlist: Array<{ value: any, name: string }> = [];
  param_max: number = 0;
  param_min: number = 0;

  @ViewChild('autosize') autosize!: CdkTextareaAutosize;
  @ViewChild('p5canvasContainer') p5canvasContainer!: ElementRef;


  private p5Instance: any;
  private materialDiameterSub: Subscription | null = null;
  private materialColorSub: Subscription | null = null;

  ngOnInit(): void {



    this.opnode = this.tree.getOpNode(this.opid);


    switch (this.param.type) {
      case 'number':
        this.param_min = (<NumParam>this.param).min;
        this.param_max = (<NumParam>this.param).max;
        this.fc = new UntypedFormControl(

          this.opnode.params[this.paramid] ?? this.param.value,
          [
            Validators.required,
            Validators.min((<NumParam>this.param).min),
            Validators.max((<NumParam>this.param).max),
          ]);
        this.fc.valueChanges.subscribe(val => {
          if (this.fc.valid) {
            this.onParamChange(val);
          }

        });
        break;

      case 'boolean':
        this.true_state_langauge = (<BoolParam>this.param).truestate;
        this.false_state_langauge = (<BoolParam>this.param).falsestate;
        this.fc = new UntypedFormControl(
          this.opnode.params[this.paramid] ?? this.param.value);
        this.fc.valueChanges.subscribe(val => {
          this.onParamChange(val);
        });
        break;

      case 'select':
        this.param_selectlist = (<SelectParam>this.param).selectlist;
        this.fc = new UntypedFormControl(this.opnode.params[this.paramid] ?? this.param.value);
        this.fc.valueChanges.subscribe(val => {
          this.onParamChange(val);
        });
        break;

      case 'file':
        this.has_image_uploaded = (<Img>this.opnode.params[this.paramid]).data !== null;
        console.log("FILE PARAM ", this.opnode.params[this.paramid], this.param.value);
        console.log("MEDIA SERVICE CONTAINS ", this.mediaService.current.slice());
        this.fc = new UntypedFormControl(this.opnode.params[this.paramid] ?? this.param.value);
        break;

      case 'string':
        const value = this.opnode.params[this.paramid] ?? this.param.value;
        this.fc = new UntypedFormControl(value, [Validators.required, Validators.pattern((<StringParam>this.param).regex)]);
        this.fc.valueChanges.subscribe(val => {
          if (!this.fc.hasError('pattern')) {
            this.onParamChange(val);
          }
        });
        break;
      case 'p5-canvas':
        this.param = <CanvasParam>this.param;
        this.fc = new UntypedFormControl(this.param.value);
        this.fc.valueChanges.subscribe(val => {
          this.onParamChange(val);
        });

        // Refresh p5 canvas when material properties change in the library
        const resetSketchOnMaterialChange = () => {
          const op = this.ops.getOp(this.opnode.name);
          if (!op) return;
          const currentParamVals = op.params.map((param, ndx) => ({
            param: param, val: this.opnode.params[ndx]
          }));
          this._resetSketch(currentParamVals);
        };
        this.materialDiameterSub = this.materialsService.materialDiameterChange
          .pipe(skip(1)).subscribe(resetSketchOnMaterialChange);
        this.materialColorSub = this.materialsService.materialColorChange
          .pipe(skip(1)).subscribe(resetSketchOnMaterialChange);
        break;

      // case 'draft':
      //   this.draftparam = <DraftParam> this.param;
      //   this.fc = new FormControl(this.draftparam.value);
      //   break;


    }






  }

  ngAfterViewInit() {
    if (this.param.type === 'p5-canvas' && this.p5canvasContainer) {
      const op = this.ops.getOp(this.opnode.name);
      if (op === undefined) return;

      const initialParamVals = op.params.map((param, ndx) => {
        return { param: param, val: this.opnode.params[ndx] }
      })

      if (!initialParamVals) return;

      setTimeout(() => this.initializeP5Canvas(initialParamVals), 0);
    }
  }

  ngOnDestroy() {
    if (this.materialDiameterSub) this.materialDiameterSub.unsubscribe();
    if (this.materialColorSub) this.materialColorSub.unsubscribe();
    if (this.p5Instance) {
      this.p5Instance.remove();
    }
  }



  // _updateString(val: string) {
  //   this.refresh_dirty = false;
  //   this.onParamChange(val);
  //   return val;
  // }



  setValueFromStateEvent(value: OpParamValType) {
    console.log("SET VALUE FROM STATE ", value)
    this.fromUser = false;

    if (this.param.type === 'file') {
      if (value !== null) {
        this.addImageFromStateChange(<Img>value)
      } else {
        this.replaceImage();
      }
    } else {
      this.fc.setValue(value);

    }


  }


  addImageFromStateChange(value: Img) {
    const instance = this.mediaService.addIndexColorMediaInstance(
      +value.id,
      'reloaded media item',
      <AnalyzedImage>value.data
    )
    this.handleFile([instance])
  }

  /**
 * changes the view and updates the tree with the new value
 * @param value 
 */
  onParamChange(value: any) {


    const opnode: OpNode = <OpNode>this.tree.getNode(this.opid);

    const change: OpStateParamChange = {
      originator: 'OP',
      type: 'PARAM_CHANGE',
      opid: this.opid,
      paramid: this.paramid,
      before: opnode.params[this.paramid],
      after: value
    }
    if (this.fromUser) this.ss.addStateChange(change);
    this.fromUser = true;

    switch (this.param.type) {

      case 'file':
        if (value == null) value = 1;
        opnode.params[this.paramid] = value;
        this.onOperationParamChange.emit({ id: this.paramid, value: value, type: this.param.type });
        break;

      case 'number':
        opnode.params[this.paramid] = value;
        this.onOperationParamChange.emit({ id: this.paramid, value: value, type: this.param.type });

        break;

      case 'boolean':
        if (value == null) value = false;
        opnode.params[this.paramid] = (value) ? 1 : 0;
        this.onOperationParamChange.emit({ id: this.paramid, value: value, type: this.param.type });
        break;

      case 'string':
        if (value == null) value = '';
        opnode.params[this.paramid] = value;
        if (!this.fc.hasError('pattern')) this.onOperationParamChange.emit({ id: this.paramid, value: value, type: this.param.type });
        break;

      case 'select':
        if (value == null) value = 0;
        opnode.params[this.paramid] = value;
        this.onOperationParamChange.emit({ id: this.paramid, value: value, type: this.param.type });
        break;

      case 'draft':
        opnode.params[this.paramid] = value;
        this.onOperationParamChange.emit({ id: this.paramid, value: value, type: this.param.type });
        break;

      case 'p5-canvas':
        // Encode p5-canvas state as base64 string (firebase strips out empty keys in objects)
        const encodedValue = btoa(JSON.stringify(value));
        opnode.params[this.paramid] = encodedValue;
        this.onOperationParamChange.emit({ id: this.paramid, value: encodedValue, type: this.param.type });
        break;
    }


  }

  openTextEditor() {

    const opnode = this.tree.getOpNode(this.opid);

    const dialogRef = this.dialog.open(TextparamComponent, { data: { val: opnode.params[this.paramid], param: this.param } });

    dialogRef.componentInstance.onUpdate.subscribe(text => {
      this.onParamChange(text);
    });



    dialogRef.afterClosed().subscribe(text => {
      this.onParamChange(text);
    });
  }


  async openImageEditor() {

    const opnode = this.tree.getOpNode(this.opid);
    let obj = this.mediaService.getMedia(+(<Img>opnode.params[this.paramid]).id);
    if (obj === undefined || obj === null) return;


    const dialogRef = this.dialog.open(ImageeditorComponent, { data: { media_id: obj.id, src: this.opnode.name } });
    dialogRef.afterClosed().subscribe(nothing => {

      let updated_media = this.mediaService.getMedia(+(<Img>this.opnode.params[this.paramid]).id)
      if (updated_media !== null) this.onParamChange({ id: (<Img>this.opnode.params[this.paramid]).id, data: <AnalyzedImage>updated_media.img });
    });
  }

  handleError(err: any) {
    this.filewarning = err;

  }

  replaceImage() {

    const opnode: OpNode = <OpNode>this.tree.getNode(this.opid);

    const img: Img = <Img>opnode.params[this.paramid];

    const change: OpStateParamChange = {
      originator: 'OP',
      type: 'PARAM_CHANGE',
      opid: this.opid,
      paramid: this.paramid,
      before: img,
      after: null
    }

    if (this.fromUser) this.ss.addStateChange(change);
    this.fromUser = true;

    this.has_image_uploaded = false;

    this.mediaService.removeInstance(+img.id)
    this.opnode.params[this.paramid] = { id: '0', data: null };
    this.onOperationParamChange.emit({ id: this.paramid, value: this.opnode.params[this.paramid], type: this.param.type });

  }






  /**
   * this is called by the upload services "On Data function" which uploads and analyzes the image data in the image and returns it as a image data object
   * @param obj 
   */
  handleFile(obj: Array<MediaInstance>) {



    this.filewarning = "";
    let img: AnalyzedImage = <AnalyzedImage>obj[0].img;

    this.opnode.params[this.paramid] = { id: obj[0].id.toString(), data: <AnalyzedImage>img };

    const change: OpStateParamChange = {
      originator: 'OP',
      type: 'PARAM_CHANGE',
      opid: this.opid,
      paramid: this.paramid,
      before: null,
      after: this.opnode.params[this.paramid]
    }
    if (this.fromUser) this.ss.addStateChange(change);
    this.fromUser = true;



    this.fc.setValue(img.name);


    if (img.warning !== '') {
      this.filewarning = img.warning;
    } else {
      this.has_image_uploaded = true;
      const opnode = this.tree.getOpNode(this.opid);
      //now update the default parameters to the original size 
      opnode.params[1] = img.width;
      opnode.params[2] = img.height;

    }


    this.onOperationParamChange.emit({ id: this.paramid, value: this.opnode.params[this.paramid], type: this.param.type });
  }

  /**
 * Public method called by parent components to explicitly reset the p5 sketch.
 * @param latestConfig The latest configuration object derived from non-canvas params.
 */
  public triggerSketchReset(latestConfig: Array<OpParamVal>, isParameterChange: boolean = true): void {
    if (this.param.type === 'p5-canvas') {
      if (!latestConfig) {
        console.error('[ParameterComponent] triggerSketchReset called without latestConfig for op:', this.opid);
        return;
      }

      this._resetSketch(latestConfig, isParameterChange);
    }
  }

  /**
   * Private helper to destroy the current p5 instance and re-initialize it
   * with the provided configuration.
   * @param latestParamVals The latest configuration object for the sketch.
   * @param isParameterChange Is reset caused by a param change (true), or file restore (false)
   */
  private _resetSketch(latestParamVals: Array<OpParamVal>, isParameterChange: boolean = false): void {
    if (this.p5Instance) {
      try {
        this.p5Instance.remove();
      } catch (e) {
        console.error('[ParameterComponent] Error removing p5 instance:', e);
      }
      this.p5Instance = null;
    }
    setTimeout(() => this.initializeP5Canvas(latestParamVals, isParameterChange), 0);
  }

  /**
   * Manage a p5.js canvas instance as an operation parameter
   *
   * Called on first load (ngAfterViewInit) and on sketch resets (_resetSketch).
   *   - Gets the operation's createSketch() function
   *   - Sets up updateCallback to communicate sketch state changes to AdaCAD
   *   - Wraps the p5 instance in a mouse-coordinate correction proxy
   *   - Instantiates the p5 sketch in the container element
   */
  initializeP5Canvas(currentParamVals: Array<OpParamVal>, isParameterChange: boolean = false) {
    if (!this.p5canvasContainer?.nativeElement) {
      console.error(`[ParameterComponent ${this.opid}] p5canvasContainer not available`);
      return;
    }

    if (this.param.type !== 'p5-canvas') {
      console.error(`[ParameterComponent ${this.opid}] param type is '${this.param.type}', expected 'p5-canvas'`);
      return;
    }

    const opNodeName = this.tree.getOpNode(this.opid)?.name;
    if (!opNodeName) {
      console.error(`[ParameterComponent ${this.opid}] could not resolve operation name`);
      return;
    }
    const operationDefinition = this.ops.getOp(opNodeName);

    if (!operationDefinition?.createSketch) {
      console.error("[ParameterComponent] Operation with p5-canvas param missing createSketch function.");
      return;
    }

    // Callback used by the sketch whenever canvas state changes
    const updateCallbackFn = (newCanvasState: any) => {
      this.param.value = newCanvasState;
      this.onParamChange(newCanvasState);
    };

    // Clean up any existing p5 instance before creating a new one
    if (this.p5Instance) {
      try {
        this.p5Instance.remove();
      } catch (e) {
        console.error('[ParameterComponent] p5 cleanup error:', e);
      }
      this.p5Instance = null;
    }

    const opInputs = this.tree.assembleOpInputs(this.opid);

    // Currently only cross_section_view uses p5-canvas params; future ops may need a different inlet convention.
    const seedDraft = opInputs[0]?.drafts?.[0] ?? null;
    let weftColors: string[];
    let weftMaterialIds: number[];
    let weftDiameters: number[];

    let warpColors: string[] = [];
    let warpDiameters: number[] = [];
    // If a second p5-canvas op is added, generalize this into an op-provided resolver.
    if (seedDraft) {
      // Cannot use Set(rowShuttleMapping) — deduplication drops entries when two systems
      // share the same material, causing index mismatches in perform().
      const weftSystemMaterialMap = new Map<number, number>();
      const weftSystemColorMap = new Map<number, string>();
      const weftSystemDiameterMap = new Map<number, number>();
      for (let i = 0; i < seedDraft.rowSystemMapping.length; i++) {
        const sys = seedDraft.rowSystemMapping[i];
        if (!weftSystemMaterialMap.has(sys)) {
          const shuttleId = seedDraft.rowShuttleMapping[i] ?? 0;
          weftSystemMaterialMap.set(sys, shuttleId);
          weftSystemColorMap.set(sys, this.materialsService.getColor(shuttleId));
          weftSystemDiameterMap.set(sys, this.materialsService.getDiameter(shuttleId));
        }
      }
      const sortedWeftSystems = [...weftSystemMaterialMap.keys()].sort((a, b) => a - b);
      weftMaterialIds = sortedWeftSystems.map(sys => weftSystemMaterialMap.get(sys)!);
      weftColors = sortedWeftSystems.map(sys => weftSystemColorMap.get(sys)!);
      weftDiameters = sortedWeftSystems.map(sys => weftSystemDiameterMap.get(sys)!);

      const systemColorMap = new Map<number, string>();
      const systemDiameterMap = new Map<number, number>();
      for (let i = 0; i < seedDraft.colSystemMapping.length; i++) {
        const sys = seedDraft.colSystemMapping[i];
        if (!systemColorMap.has(sys)) {
          const shuttleId = seedDraft.colShuttleMapping[i] ?? 0;
          systemColorMap.set(sys, this.materialsService.getColor(shuttleId));
          systemDiameterMap.set(sys, this.materialsService.getDiameter(shuttleId));
        }
      }
      const sortedSystems = [...systemColorMap.keys()].sort((a, b) => a - b);
      warpColors = sortedSystems.map(sys => systemColorMap.get(sys)!);
      warpDiameters = sortedSystems.map(sys => systemDiameterMap.get(sys)!);
    } else {
      // Default mode: use AdaCAD's built-in material colors (skip 0=black, 1=white)
      weftMaterialIds = [2, 3, 4, 5, 6, 7, 8, 9, 10];
      weftColors = weftMaterialIds.map(id => this.materialsService.getColor(id));
      weftDiameters = weftMaterialIds.map(id => this.materialsService.getDiameter(id));
    }

    const userSketchProvider = operationDefinition.createSketch(currentParamVals, updateCallbackFn, { isParameterChange, weftColors, weftMaterialIds, warpColors, weftDiameters, warpDiameters }, opInputs);

    // Wrapper for p5 to apply a mouse-coordinate proxy to correct for AdaCAD's CSS scaling
    // Compares canvas buffer size and display size
    const sketchWrapper = (actualP5Instance: any) => {
      this.p5Instance = actualP5Instance;

      const P5MouseProxyHandler: ProxyHandler<any> = {
        get: (target, prop, receiver) => {
          if (prop === 'mouseX' || prop === 'mouseY') {
            if (!target.canvas || !target._setupDone) {
              const fallback = Reflect.get(target, prop, receiver);
              return typeof fallback === 'number' ? fallback : 0;
            }
            const rect = target.canvas.getBoundingClientRect();
            const raw = Reflect.get(target, prop, receiver);
            const isX = prop === 'mouseX';
            const displaySize = isX ? rect.width : rect.height;
            const bufferSize = isX ? target.width : target.height;
            if (displaySize > 0 && bufferSize > 0 && typeof raw === 'number') {
              return raw * (bufferSize / displaySize);
            }
            return typeof raw === 'number' ? raw : 0;
          }
          return Reflect.get(target, prop, receiver);
        },
      };

      const proxiedP5Instance = new Proxy(actualP5Instance, P5MouseProxyHandler);
      userSketchProvider(proxiedP5Instance);
    };

    new p5.default(sketchWrapper as any, this.p5canvasContainer.nativeElement);
  }




}




